module.exports = __webpack_public_path__ + "media/images/service/a_4-bedd8cd67ad14045ef7f8a5d974c9f0b.png";